// extracted by mini-css-extract-plugin
export default {"centralWallet":"centralWallet_centralWallet__hcCiL","line":"centralWallet_line__AJji8","Wallet_content":"centralWallet_Wallet_content__e8lmp"};